import { Link } from "react-router-dom";
import { IoMdSunny } from "react-icons/io";
import { FaMoon, FaBandcamp, FaBars, FaSoundcloud, FaUser } from 'react-icons/fa'
import { AiFillYoutube } from 'react-icons/ai'
import { useEffect, useState } from "react";

const Header = ({setShowLogin,showLogin}) => {
  const [darkMode, setDarkMode] = useState(JSON.parse(localStorage.getItem("darkMode")) || false);
  const [mobile, setMobile] = useState(false);
  useEffect(() => {
    localStorage.setItem("darkMode", JSON.stringify(darkMode))
    if (darkMode) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.removeAttribute("class");
    }
  }, [darkMode])
  return (
    <header className="font-[blanka] bg-custom-gradient-1 dark:bg-custom-gradient-2">
      <section className="max-w-screen-xl m-auto p-4 flex justify-between items-center">
        <div className="flex-1">
          <Link to='/'>
            <div className="flex items-center">
              <img className="w-12" src="./logo.png" alt="logo" />
              <span className="text-2xl">
                <span className="text-secondary dark:text-white">Studio</span>
                <span className="text-white">Mercy</span>
              </span>
            </div>
          </Link>
        </div>
        <nav className="hidden lp:flex flex-1 gap-4 justify-center text-lg dark:text-white">
          <Link to='/' className="transition-colors hover:dark:text-primary hover:text-secondary">Home</Link>
          <Link to='/albums' className="transition-colors hover:dark:text-primary hover:text-secondary">Albums</Link>
          <Link to='/blog' className="transition-colors hover:dark:text-primary hover:text-secondary">Blog</Link>
          <a className="transition-colors hover:dark:text-primary hover:text-secondary" href="https://studio-mercy-shop.fourthwall.com" target="_blank" rel="noreferrer">Merch</a>
          <Link to='/contact' className="transition-colors hover:dark:text-primary hover:text-secondary">Contact</Link>
        </nav>
        <div className="flex-1 flex items-center justify-end gap-2 md:gap-4">
          <div className="text-2xl hidden lp:flex items-center gap-2">
            <a href="https://www.youtube.com/channel/UCGdC267vaPQCaKd6kDv6CjA" rel="noreferrer" target="_blank"><AiFillYoutube className="text-red-600" /></a>
            <a href="https://studiomercyofficial.bandcamp.com/" rel="noreferrer" target="_blank"><FaBandcamp className="text-[#1e9abe]" /></a>
            <a href="https://soundcloud.com/studiomercy" rel="noreferrer" target="_blank"><FaSoundcloud className="text-[#fc6800]" /></a>
          </div>
          <div className="bg-slate-700 dark:bg-yellow-100 text-white dark:text-yellow-500 rounded-full text-xs md:text-md p-2 cursor-pointer" onClick={() => setDarkMode(!darkMode)}>
            {darkMode ? <IoMdSunny /> : <FaMoon />}
          </div>
          <div onClick={()=> setShowLogin(!showLogin)} to='/' className="bg-secondary text-xs md:text-md text-white rounded-full p-2 cursor-pointer">
            <FaUser />
          </div>
          <div>
            <FaBars onClick={() => setMobile(!mobile)} className="block lp:hidden text-black cursor-pointer text-xl dark:text-light" />
          </div>
        </div>
        {
          mobile &&
          <div>
            <div className="absolute top-32 left-0 right-0 z-20 dark:text-white  bg-custom-gradient-1 dark:bg-custom-gradient-2 px-8 py-4 flex flex-col gap-4 ">
              <Link to='/'>Home</Link>
              <Link to='/albums'>Albums</Link>
              <Link to='/blog'>Blog</Link>
              <a href="https://studio-mercy-shop.fourthwall.com" rel="noreferrer" target="_blank" >Merch</a>
              <Link to='/contact'>Contact</Link>
              <div className="text-2xl flex items-center gap-2">
                <a href="https://www.youtube.com/channel/UCGdC267vaPQCaKd6kDv6CjA" rel="noreferrer" target="_blank"><AiFillYoutube className="text-red-600" /></a>
                <a href="https://studiomercyofficial.bandcamp.com/" rel="noreferrer" target="_blank"><FaBandcamp className="text-[#1e9abe]" /></a>
                <a href="https://soundcloud.com/studiomercy" rel="noreferrer" target="_blank"><FaSoundcloud className="text-[#fc6800]" /></a>
              </div>
            </div>
          </div>
        }
      </section>
    </header>
  )
}

export default Header